<template>
	<div class="position-relative">>
	    <transition name="vue-table-loader">
	        <div class="vue-table-loader alt" v-if="loading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
	    </transition>
		<div class="row">
			<div class="col-md-4">
				<base-filter-bar placeholder="Search Price Filters"></base-filter-bar>
			</div>
			<div class="col-md-8">
				<base-select-visible :per-page="perPage" :amounts-shown="amountsShown"></base-select-visible>
			</div>
		</div>
		<div class="dataTables_wrapper container-fluid dt-bootstrap4">
		    <vuetable ref="vuetable"
				:api-url="grid"
				:fields="fields"
				:css="css.table"
				:per-page="perPage"
				noDataTemplate="No Price Filters Found"
				:append-params="moreParams"
				pagination-path=""
				@vuetable:pagination-data="onPaginationData"
				@vuetable:loaded="onLoaded"
		    >
	    	    <template slot="actions" slot-scope="props">
	    	    	<div class="action-container clearfix">
		    	    	<transition v-bind:name="confirmDelete.transitionValue">
			    	    	<div v-if="confirmDelete.id == props.rowData.id" class="btn-group btn-confirm-delete">
			    	    		<a class="btn btn-danger" :href="'/price-rule-engine/sets/' + priceRuleSetId + '/rules/' + priceRuleId + '/product-filters/' + props.rowData.id"><span>Confirm</span>	</a>
			    	    		<div class="btn btn-outline-danger" @click="cancelDeletion()"><i class="fa fa-times" aria-hidden="true"></i></div>
			    	    	</div>

			    	    	<button class="btn btn-danger btn-start-confirmation" @click="confirmDeletion(props.rowData.id)" v-if="confirmDelete.id != props.rowData.id"><span>Delete</span>	</button>
			    		</transition>
	    	    	</div>
		    	</template>

		    	<template slot="entityProperty" slot-scope="props">
	    	    	<span v-if="props.rowData.entity == 'product_category' || props.rowData.entity == 'product_brand'">name</span>
	    	    	<span v-else>{{props.rowData.entity_property}}</span>
		    	</template>
		    </vuetable>
		    <div class="row">
		    	<div class="col-md-6">
		    		<base-pagination-info
		    			:css="css.table"
		    			ref="paginationInfo"
		    		>
		    		</base-pagination-info>
		    	</div>
		    	<div class="col-md-6">
		    		<base-pagination  ref="pagination"
		    		  @vuetable-pagination:change-page="onChangePage"
		    		></base-pagination>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<style scoped lang="scss">
	.btn-confirm-delete{
		.btn{
			padding: 11px 8px 9px 8px;
			&:last-child{
				z-index: 10;
				// border-left:1px solid #ff9a9a;
			}
		}
	}
	.action-container{
		position: relative;
		overflow: hidden;
		height: 38px;
		width: 88px;
		background-color: #ef534f;
		border-radius: 2px;
		.btn-confirm-delete, .btn-start-confirmation{
			position: absolute;
			top: 0;
		}
	}
	.slide-reverse-leave-active,
	.slide-reverse-enter-active,
	.slide-leave-active,
	.slide-enter-active {
	  transition: 0.4s;
	}
	.slide-enter {
	  transform: translate(-100%, 0);
	  span{
	  	transition: opacity 0.4s;
	  	opacity: 1;
	  }
	}
	.slide-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	  transform: translate(100%, 0);
	}

	.slide-reverse-enter {
	  transform: translate(100%, 0);
	  span{
	  	transition: opacity 0.4s;
	  	opacity: 1;
	  }
	}
	.slide-reverse-leave-to {
		span{
			transition: opacity 0.4s;
			opacity: 0;
		}
	  transform: translate(-100%, 0);
	}
</style>

<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import * as Vuetable from 'vuetable-2';
	import moment from 'moment';
	import BaseFilterBar from './base-filter-bar.vue';
	import BasePagination from './base-pagination.vue';
	import BasePaginationInfo from './base-pagination-info.vue';
	import BaseSelectVisible from './base-select-visible.vue';

	Vue.use(VueEvents)

	export default {
	    name: 'price-rule-show',
	    props: ['priceRuleId', 'priceRuleSetId'],
	    components:{
	    	'base-filter-bar': BaseFilterBar,
	    	'base-pagination': BasePagination,
	    	'base-pagination-info': BasePaginationInfo,
	    	'base-select-visible': BaseSelectVisible,
	    },
	    data() {
	    	return {
	    		perPage: 10,
	    		moreParams: {},
	    		loading: true,
				fields: [
					{
						name: 'entity',
						sortField: 'entity',
					},
					{
						name: '__slot:entityProperty',
						title: 'Property',
						sortField: 'entity_property',
					},
					{
						name: 'criteria_type',
						title: 'Criteria Type',
						sortField: 'criteria_type',
					},
					{
						name: 'criteria_string',
						title: 'Criteria',
						sortField: 'criteria_string',
					},
					{
						name: '__slot:actions',
						titleClass: 'actions-single-column',
					},
				],
				amountsShown: [
					{ text: '10', value: 10 },
					{ text: '25', value: 25 },
					{ text: '50', value: 50 },
					{ text: '100', value: 100 }
				],
				confirmDelete:{
					id: null,
					transitionValue: 'slide',
					isActive: false,
				},
				grid: base_url + "/price-rule-engine/rule/grid/" + this.priceRuleId,
				css: {
					table: {
						tableClass: 'table table-striped table-bordered',
						ascendingIcon: 'sort-icon-asc',
						descendingIcon: 'sort-icon-desc',
						infoClass: '',
					},
				},
			}
	    },
	    mounted() {
	    	this.$events.$on('per-page', eventData => this.doVisibleSet(eventData))
           	this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
           	this.$events.$on('filter-reset', e => this.onFilterReset())
	    },
	    watch: {
			'perPage' (val, oldVal) {
		      this.$nextTick(function() {
		        	this.$refs.vuetable.refresh()
		      })
		    },
	    },
	    methods: {
	        confirmDeletion (id) {
	        	if (this.confirmDelete.isActive == true) {
		          	this.cancelDeletion()
	        	}else{
					this.confirmDelete.isActive = true;
				  	this.confirmDelete.id = id;
				  	this.confirmDelete.transitionValue = 'slide-reverse'
	        	}
	        },
			cancelDeletion () {
				this.confirmDelete.isActive = false;
				this.confirmDelete.transitionValue = 'slide'
	          	this.confirmDelete.id = null;
	        },
	         onPaginationData (paginationData) {
	          	this.$refs.pagination.setPaginationData(paginationData)
	          	this.$refs.paginationInfo.setPaginationData(paginationData)
	        },
	        onChangePage (page) {
	          	this.$refs.vuetable.changePage(page)
	        },
	        editRow(rowData){
	        	console.log(rowData);
	        },
	        doVisibleSet (perPageValue) {
                this.perPage = perPageValue;
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
	        onFilterSet (filterText) {
                this.moreParams = {
                    'filter': filterText
                }
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onFilterReset () {
                this.moreParams = {}
                Vue.nextTick( () => this.$refs.vuetable.refresh())
            },
            onLoaded: function () {
                this.loading = false;
            }
		}
	};
</script>